import { ColumnLinks } from '../../types';
import { DesktopMenuLink, DesktopMenuTitle } from '../desktopMenu.style';
import styled from 'styled-components';

export const DesktopMenuColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

type Props = {
  links: ColumnLinks;
};

export const DesktopMenuColumnLinks = ({ links }: Props) => {
  return (
    <DesktopMenuColumn>
      <DesktopMenuTitle>{links.title}</DesktopMenuTitle>
      {links.links.map(({ href, text }) => (
        <DesktopMenuLink key={href} href={href}>
          {text}
        </DesktopMenuLink>
      ))}
    </DesktopMenuColumn>
  );
};
